import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SortBot } from '../../../app/helpers/sort';
import { Angular2Csv } from 'angular2-csv';
import { Router } from '@angular/router';
import { BillingCreditsArray } from '../../../app/models/ss-api/responses/billing.credits.response';
import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'credit-report',
    templateUrl: './credit.report.component.html',
    styleUrls: ['./credit.report.component.css']
})
export class CreditReportComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    Credits: BillingCreditsArray;
    CreditFilterInput: string;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 25;

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('Credit Report');
        this.LoadCredits();
    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.Credits = SortBot.SortAuto(this.Credits, sortVar1, sortVar2);
    }

    LoadCredits() {
        this.IsBusy = true;

        let disposable = this.api.GetMemberCredits().subscribe(response => {
            this.IsBusy = false;

            this.Credits = response.Data;

            disposable.unsubscribe();
        });
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Member', 'Email', 'Credit']
        };

        let ExportData = [];

        this.Credits.forEach(function (item) {
            ExportData.push({
                Member: item.FirstName + ' ' + item.LastName,
                Email: item.Email,
                Credit: item.Credit
            });
        });

        new Angular2Csv(ExportData, 'CreditReport', options);
    }

    OnMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    OnLicenseClick(licenseKey: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(licenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.LoadCredits();
        });
    }

    paginateCredits(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    TotalCredits() {
        let total = 0;

        this.Credits.forEach(function (credit) {
            total += credit.Credit;
        });

        return total.toFixed(2);
    }

    CreditsTitle() {
        if (this.Credits && this.Credits.length > 0) {
            return 'Credits (' + this.Credits.length + ' Records - $' + this.TotalCredits() + ')';
        } else {
            return 'Credits';
        }
    }

}
